import { QuantityInput } from 'browser/components/atomic-elements/atoms/input/quantity-input'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const QuantityField = LabelFieldFactory({ InputComponent: QuantityInput })
export { QuantityField }
